module.exports = __webpack_public_path__ + "static/cediaLogo-e534832010a5766d4f5876f38271a20c.png";